import styled from 'styled-components';
import { Typography } from 'antd';
import { light_theme_tokens } from '@/styles/themes/tokens';

const { Text } = Typography;

const WHITE_BLUE_COLOR = '#EBEEFD';
const BLUE_COLOR = '#2F54EB';

export const ResultBadgeContainer = styled.div`
	min-width: 3.5rem;
	padding: 8px 16px;
	background-color: ${WHITE_BLUE_COLOR};
	border: 1px solid ${BLUE_COLOR};
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;

	p {
		margin: 0;
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		color: ${BLUE_COLOR};
		text-align: center;

		strong {
			font-weight: 600;
		}
	}
`;

export const ResultBadgeDisabled = styled.div`
	min-width: 56px;
	width: 63px;
	padding: 8px 16px;
	background-color: ${light_theme_tokens.secondary_colors['150']};
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;

	p {
		margin: 0;
		font-size: 16px;
		font-weight: 600;
		line-height: 24px;
		color: ${light_theme_tokens.secondary_colors['400']};
		text-align: center;
	}
`;

export const PartialResultWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	width: 100%;
`;

export const PartialResultContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	align-items: center;
`;

export const PartialResultHeader = styled(Text)`
	&& {
		font-size: 16px;
		font-weight: 600;
		line-height: 24px;
		color: ${light_theme_tokens.secondary_colors['400']};
		text-align: center;
	}
`;

export const PartialResultContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	align-items: center;
`;

export const PartialResultLabels = styled.div`
	display: flex;
	gap: 16px;
	align-items: center;
`;

export const PartialResultLabel = styled(Text)`
	&& {
		font-size: 14px;
		font-weight: 400;
		line-height: 16px;
		color: ${light_theme_tokens.secondary_colors['400']};
		text-align: center;
		min-width: 63px;
	}
`;

export const PartialResultDivider = styled.div`
	width: 1px;
	height: 16px;
	background-color: ${light_theme_tokens.secondary_colors['150']};
`;

export const PartialResultValues = styled.div`
	display: flex;
	gap: 16px;
	align-items: center;
`;
